import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { User } from '../../../models/user';
import { AuthService } from '../../../services/auth.service';
import { ConfirmDialog } from '../../common/confirm-dialog/confirm-dialog';

@Component({
  selector: 'app-auth-button',
  imports: [
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatMenuModule,
    MatDividerModule,
    MatDialogModule,
  ],
  templateUrl: './auth-button.html',
  styleUrl: './auth-button.scss',
})
export class AuthButton implements OnInit {
  constructor(private authService: AuthService, private dialog: MatDialog) {}

  get profile(): User | null {
    return this.authService.profile();
  }

  ngOnInit(): void {
    this.authService.getProfile();
  }

  logout() {
    this.dialog
      .open(ConfirmDialog, {
        data: { title: 'Logout', content: 'Are you sure you want to logout?' },
      })
      .afterClosed()
      .subscribe((result) => {
        console.log(result);
        if (result) {
          this.authService.logout();
        }
      });
  }
}
